import router from '@/router'
import axios from 'axios'
import { showToast } from 'vant'

const API_ROOT = import.meta.env.VITE_API_ROOT

const api = axios.create({
  baseURL: API_ROOT,
})

// 接口请求前
api.interceptors.request.use((request) => {
  let token = localStorage.getItem('ltu.token')
  if (token) {
    request.headers['Authorization'] = `Bearer ${token}`
    return request
  }
  return request
})

// 接口响应后
api.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    if (
      error.code === 'ECONNABORTED' ||
      error.message === 'Network Error' ||
      error.message.includes('timeout')
    ) {
      showToast('当前网络异常')
      return Promise.reject({ message: '当前网络异常' })
    }

    if (error.response) {
      const { status, data } = error.response
      switch (status) {
        case 401:
          localStorage.removeItem('ltu.token')
          router.push({ name: 'login-forbidden', query: { type: 'unauthorized' } }).catch(() => {})
          return Promise.reject(data)
        case 403:
          localStorage.removeItem('ltu.token')
          router
            .push({ name: 'login-forbidden', query: { type: 'permission-denied' } })
            .catch(() => {})
          return Promise.reject(data)
        case 400:
          if (data.code === 1314) {
            router.push({ name: 'login-complete' }).catch(() => {})
            return Promise.reject(data)
          } else if (data.code === 1302) {
            router.push({ name: 'personal-transform' }).catch(() => {})
            return Promise.reject(data)
          } else if (data.code === 1501) {
            return Promise.reject(data)
          } else {
            showToast(data.message)
            return Promise.reject(data)
          }
        default:
          return Promise.reject(data)
      }
    }

    return Promise.reject(error.response ? error.response.data : { message: '未知错误' })
  }
)

export default api
